import React from 'react';
import withField from '../withField';

export const Hidden = withField(({
    /* rff render props */
    input,
    meta,

    /* user provided props */
    id,
    name,
    ...other
}) => {
    return (
        <input
            id={id}
            name={name}
            {...input}
            {...other}
            type="hidden"
        />
    );
});
